(() => {
  'use strict';
  const log = (level, operation, context = {}) => {
    (level === 'ERROR' ? console.error : console.info)({timestamp:new Date().toISOString(),level,module:'mms-product-details.js',operation,...context});
  };
  try {
    const plain = text => text.normalize('NFKC').replace(/\s+/g, ' ').trim();
    const heading = text => {
      const clean = plain(text).replace(/^[^a-z0-9]+/i, '');
      const match = clean.match(/^(production\s*(?:&|and)\s*(?:shipping|delivery)|shipping availability|shipping(?:\s*(?:&|and)\s*(?:returns?|delivery))?|made for your order|questions\s*(?:&|and)\s*support|questions or a custom request|questions|support|delivery\s*(?:&|and)\s*support|returns?\s*(?:&|and)\s*(?:refunds?|exchanges))(?:\s*[:?—-]\s*|\s+|$)(.*)$/i);
      if (!match) return null;
      if (match[2] && match[1] !== match[1].toUpperCase()) return null;
      return {kind:/questions|support|return/i.test(match[1]) ? 'support' : /availability|^shipping$/i.test(match[1]) ? 'shipping' : 'production', rest:match[2]};
    };
    const linesOf = node => {
      const read = part => part.nodeType === Node.TEXT_NODE ? part.textContent : part.nodeType !== Node.ELEMENT_NODE ? '' : part.tagName === 'BR' ? '\n' : [...part.childNodes].map(read).join('') + (/^(P|LI|H[1-6]|UL|OL|DIV)$/.test(part.tagName) ? '\n' : '');
      return read(node).split(/\n+/).map(line=>line.trim()).filter(Boolean);
    };
    document.querySelectorAll('[data-product-description]').forEach(description => {
      if (description.dataset.serviceMerged === 'true') return;
      const content = description.querySelector('[data-description-content]');
      const details = description.closest('[data-item-details]');
      if (!content || !details) return;
      const textSlice = (node, start, end = node.textContent.length) => {
        const walker=document.createTreeWalker(node,NodeFilter.SHOW_TEXT),range=document.createRange();
        let offset=0,part,started=false;
        while((part=walker.nextNode())){
          const length=part.textContent.length;
          if(!started && start<=offset+length){range.setStart(part,Math.max(0,start-offset));started=true;}
          if(started && end<=offset+length){range.setEnd(part,Math.max(0,end-offset));return range.cloneContents();}
          offset+=length;
        }
        return document.createDocumentFragment();
      };
      const disclaimers=[],disclaimerKeys=new Set();
      const disclaimerPattern=/\b(?:not\s+(?:affiliated|associated|endorsed|sponsored|licensed)\b|no\s+(?:official\s+)?affiliation\b|non[- ]affiliation\b|not\s+(?:an?\s+)?official\s+(?:product|tourism|government|emblem)\b)/i;
      content.querySelectorAll('p,li').forEach(paragraph=>{
        if(paragraph.querySelector('p,li'))return;
        const text=paragraph.textContent;
        if(!disclaimerPattern.test(text))return;
        let start=0,end=text.length;
        if(/^\s*(?:Contact|Message)\b/i.test(text)){
          const index=text.search(/This original design is not affiliated/i);
          if(index<0)return;start=index;
        }
        if(paragraph.tagName==='LI'){
          const index=text.search(/\b(?:Not affiliated|Not associated|No affiliation)\b/i);
          if(index>0)start=index;
        }
        const availability=text.indexOf('Available size/color combinations');
        if(availability>start)end=availability;
        const note=document.createElement('p');note.className='product-disclaimer';note.append(textSlice(paragraph,start,end));
        const key=plain(note.textContent);
        if(!disclaimerKeys.has(key)){disclaimers.push(note);disclaimerKeys.add(key);}
        if(start===0 && end===text.length)paragraph.remove();
        else{
          const kept=document.createDocumentFragment();
          if(start>0)kept.append(textSlice(paragraph,0,start));
          if(end<text.length)kept.append(textSlice(paragraph,end));
          paragraph.replaceChildren(kept);
        }
      });
      const notes = new Set();
      let removedBlocks = 0;
      const mergeLine = (raw, links) => {
        const text = plain(raw).replace(/^[•·*\-]\s*/, '');
        if (!text) return true;
        if (/not (?:a )?digital|^this is (?:a )?physical|props|gift packaging|printed colo|screen colo|monitor|microwave|dishwasher|not a two.mug/i.test(text)) return false;
        const kind = /contact|message|questions?|support|help|damag|defect|incorrect|cancel|returns?|refund|replacement/i.test(text) ? 'support'
          : /made[ -]to[ -]order|production|printing|tracking|artwork approval|printed.*ship/i.test(text) ? 'production'
          : /checkout|shipping (?:cost|charge|rate|option|service)|destination|offered to|United States|Canada|customs|import|VAT/i.test(text) ? 'shipping'
          : /ship|deliver|transit|packag|dispatch/i.test(text) ? 'delivery' : null;
        if (!kind) return false;
        const specific = /\d|United States|Canada|U\.S\.|United Kingdom|Europe|international|customs|dut(?:y|ies)|VAT|import|refund|replacement|return|cancel|quality check|inspected|PO box|military|not (?:available|supported)|only (?:ships|available)/i.test(text);
        if (specific) {
          const key = text.toLowerCase().replace(/[^a-z0-9]/g, '');
          if (!notes.has(key)) {
            const target = details.querySelector('[data-service-point="'+(/^(?:shipping|delivery)$/.test(kind) ? 'production' : kind)+'"]');
            if (!target) return false;
            const note = document.createElement('p');
            note.className = 'product-service-note';
            note.textContent = text;
            links.forEach(link => {
              const label=link.textContent.trim(),href=link.getAttribute('href');
              if(!label||!text.includes(label)||!href||!/^(https?:|mailto:|\/)/i.test(href))return;
              const walker=document.createTreeWalker(note,NodeFilter.SHOW_TEXT);
              let part;
              while((part=walker.nextNode())){
                const index=part.textContent.indexOf(label);
                if(index<0)continue;
                const anchor=document.createElement('a');anchor.href=href;anchor.textContent=label;
                part.replaceWith(document.createTextNode(part.textContent.slice(0,index)),anchor,document.createTextNode(part.textContent.slice(index+label.length)));
                break;
              }
            });
            target.append(note);
            notes.add(key);
          }
        }
        return true;
      };
      const process = parent => {
        let activeSection = null;
        [...parent.childNodes].forEach(node => {
          if (node.nodeType === Node.TEXT_NODE && !node.textContent.trim()) return;
          if (node.nodeType === Node.ELEMENT_NODE && /^(DIV|SECTION)$/.test(node.tagName)) {process(node);return;}
          const lines = linesOf(node);
          const links=node.nodeType===Node.ELEMENT_NODE?[...node.querySelectorAll('a[href]')]:[];
          if (!lines.length) return;
          const firstHeading = heading(lines[0]);
          const isHeadingNode = node.nodeType === Node.ELEMENT_NODE && /^H[1-6]$/.test(node.tagName);
          if (isHeadingNode) {
            activeSection = firstHeading?.kind || null;
            if (firstHeading || /^(?:item|product) details$/i.test(plain(node.textContent))) {node.remove();removedBlocks++;}
            return;
          }
          const standalone = /^(?:fixed artwork|made to order|each (?:piece|item) is made to order)/i.test(plain(node.textContent));
          if (!activeSection && !firstHeading && !standalone && !lines.some(line=>heading(line))) return;
          let section = activeSection, changed = false;
          const kept = [];
          lines.forEach(line => {
            const label = heading(line);
            if (label) {section=label.kind;changed=true;line=label.rest;if(!line)return;}
            else if (/^[^a-z]*[A-Z][A-Z\s&/—-]{3,}[:?]?$/.test(line)) {section=null;kept.push(line);return;}
            if (!section && !standalone) {kept.push(line);return;}
            const sentences = line.split(/(?<=[.!?;])\s+(?=[A-Z])/);
            const remaining = sentences.filter(sentence=>!mergeLine(sentence,links));
            if (remaining.length !== sentences.length) changed = true;
            if (remaining.length) kept.push(remaining.join(' '));
          });
          if (firstHeading && lines.length===1 && !firstHeading.rest) activeSection=firstHeading.kind;
          if (!changed) return;
          removedBlocks++;
          if (!kept.length) {node.remove();return;}
          const replacement = document.createElement('p');
          kept.forEach((line,index)=>{if(index)replacement.append(document.createElement('br'));replacement.append(document.createTextNode(line));});
          node.replaceWith(replacement);
        });
      };
      process(content);
      const sectionInfo = text => {
        const label = plain(text).replace(/^[^a-z0-9]+/i, '').replace(/[:?]+$/, '').trim();
        let icon;
        if (/^about (?:the )?(?:design|artwork|art|shirt)$/i.test(label) || /^two.sided design$/i.test(label)) icon='pencil';
        else if (/^(?:perfect for|gift ideas)$/i.test(label)) icon='gift';
        else if (/^(?:(?:accent |ceramic |enamel )?mug|tumbler) details$/i.test(label)) icon='cup';
        else if (/^(?:[a-z /&-]+ details|size guide)$/i.test(label)) icon=/personalization|model selection/i.test(label)?'check':'ruler';
        else if (/^(?:materials?|fabric)$/i.test(label)) icon='layers';
        else if (/^care(?: & (?:fit|support))?$/i.test(label)) icon='sparkle';
        else if (/^(?:your personalization|personalization & model selection|how your custom order works)$/i.test(label)) icon='check';
        else if (/^quote$/i.test(label)) icon='info';
        if (!icon) return null;
        return {icon,label:label===label.toUpperCase()?label.charAt(0)+label.slice(1).toLowerCase():label};
      };
      const makeHeading = info => {
        const title=document.createElement('h3');title.className='product-detail-heading';
        const icon=document.createElement('span');icon.className='product-detail-icon';
        const template=details.querySelector('template[data-detail-icon="'+info.icon+'"]');
        if(template)icon.append(template.content.cloneNode(true));
        const label=document.createElement('span');label.textContent=info.label;
        title.append(icon,label);return title;
      };
      const inlineLines = node => {
        if(node.nodeType===Node.TEXT_NODE)return node.textContent.split(/\r?\n/).map(text=>{const part=document.createDocumentFragment();part.append(document.createTextNode(text));return part;});
        if(node.nodeType!==Node.ELEMENT_NODE)return [document.createDocumentFragment()];
        if(node.tagName==='BR')return [document.createDocumentFragment(),document.createDocumentFragment()];
        const lines=[document.createDocumentFragment()];
        [...node.childNodes].forEach(child=>{
          const parts=inlineLines(child);lines[lines.length-1].append(parts.shift());lines.push(...parts);
        });
        if(node.tagName==='P')return lines;
        return lines.map(line=>{const wrapper=node.cloneNode(false);wrapper.append(line);const part=document.createDocumentFragment();part.append(wrapper);return part;});
      };
      const splitTitle = line => {
        const info=sectionInfo(line.textContent);
        if(info)return {info,rest:null};
        const match=line.textContent.match(/^(\s*[^A-Za-z0-9]*(?:ABOUT THE (?:DESIGN|ARTWORK|ART|SHIRT)|PERFECT FOR|GIFT IDEAS|(?:[A-Z]+[ &/-]+){0,4}DETAILS|CARE(?: & (?:FIT|SUPPORT))?|QUOTE|SIZE GUIDE))\s+([\s\S]+)$/);
        if(!match)return null;
        const prefix=sectionInfo(match[1]);if(!prefix)return null;
        let offset=match[0].length-match[2].length;
        const walker=document.createTreeWalker(line,NodeFilter.SHOW_TEXT);let text;
        while((text=walker.nextNode())){
          if(offset>text.textContent.length){offset-=text.textContent.length;continue;}
          const range=document.createRange();range.setStart(text,offset);range.setEnd(line,line.childNodes.length);
          return {info:prefix,rest:range.cloneContents()};
        }
        return null;
      };
      const decorate = parent => {
        [...parent.childNodes].forEach(node=>{
          if(node.nodeType===Node.ELEMENT_NODE && /^(DIV|SECTION)$/.test(node.tagName)){decorate(node);return;}
          if(node.nodeType===Node.ELEMENT_NODE && /^H[2-6]$/.test(node.tagName)){
            node.replaceWith(makeHeading(sectionInfo(node.textContent)||{icon:'info',label:plain(node.textContent)}));return;
          }
          if(node.nodeType!==Node.TEXT_NODE && !(node.nodeType===Node.ELEMENT_NODE && node.tagName==='P'))return;
          const lines=inlineLines(node);
          if(!lines.some(line=>splitTitle(line)))return;
          const replacement=document.createDocumentFragment();let paragraph=null;
          lines.forEach(line=>{
            const title=splitTitle(line);
            if(title){replacement.append(makeHeading(title.info));paragraph=null;if(!title.rest)return;line=title.rest;}
            if(!line.textContent.trim())return;
            if(!paragraph){paragraph=document.createElement('p');replacement.append(paragraph);}else paragraph.append(document.createElement('br'));
            paragraph.append(line);
          });
          node.replaceWith(replacement);
        });
        let body=null;
        [...parent.childNodes].forEach(node=>{
          if(node.nodeType===Node.ELEMENT_NODE && node.classList.contains('product-detail-heading')){
            const section=document.createElement('section');section.className='product-description-section';
            node.before(section);section.append(node);body=document.createElement('div');body.className='product-description-section-content';section.append(body);
          }else if(body)body.append(node);
        });
      };
      decorate(content);
      content.querySelectorAll('p').forEach(paragraph=>{
        const lines=inlineLines(paragraph);
        if(!lines.some(line=>/^\s*[•·]\s*/.test(line.textContent)))return;
        const output=document.createDocumentFragment();let list=null,body=null;
        lines.forEach(line=>{
          const bullet=line.textContent.match(/^\s*[•·]\s*/);
          if(bullet){
            body=null;
            if(!list){list=document.createElement('ul');list.className='product-detail-list';output.append(list);}
            const item=document.createElement('li');item.append(textSlice(line,bullet[0].length));list.append(item);
          }else if(line.textContent.trim()){
            list=null;
            if(!body){body=document.createElement('p');output.append(body);}else body.append(document.createElement('br'));
            body.append(line);
          }
        });
        paragraph.replaceWith(output);
      });
      content.querySelectorAll('.product-detail-list').forEach(list=>{
        let next=list.nextSibling;
        while(next && next.nodeType===Node.TEXT_NODE && !next.textContent.trim()){const empty=next;next=next.nextSibling;empty.remove();}
        while(next?.nodeType===Node.ELEMENT_NODE && next.classList.contains('product-detail-list')){
          const extra=next;list.append(...extra.childNodes);next=extra.nextSibling;extra.remove();
        }
      });
      content.querySelectorAll('p').forEach(paragraph=>{
        if(!paragraph.textContent.trim() && !paragraph.querySelector('img,video,iframe'))paragraph.remove();
      });
      details.append(...disclaimers);
      description.dataset.serviceMerged='true';
      log('INFO','DESCRIPTION_SERVICES_MERGED',{removedBlocks,uniqueServiceNotes:notes.size,disclaimers:disclaimers.length});
    });
    document.querySelectorAll('[data-product-form]').forEach(form => {
      form.querySelectorAll('[data-character-count]').forEach(input => {
        const counter=document.getElementById(input.getAttribute('aria-describedby'));
        const update=()=>{counter.textContent=`${input.value.length}/${input.maxLength}`;};
        input.addEventListener('input',update);update();
      });
      const panel=form.querySelector('.personalization-panel');
      form.addEventListener('invalid',()=>{if(panel)panel.open=true;},true);
      const upload=form.querySelector('[data-photo-upload]');
      form.querySelector('[data-photo-remove]')?.addEventListener('click',()=>{upload.value='';upload.dispatchEvent(new Event('change',{bubbles:true}));upload.focus();});
      const variant=form.querySelector('[name=id]');
      const controls = [...form.querySelectorAll('[data-product-option]')];
      const variantFallback = form.querySelector('[data-variant-fallback]');
      const choicesPanel = form.querySelector('[data-product-options]');
      if (variant && variantFallback) {
        const choices = [...variant.options].filter(option => option.dataset.mmsAvailable === 'true').map(option => ({
          option, values: JSON.parse(option.dataset.options), available: option.dataset.mmsAvailable === 'true'
        }));
        const submit = form.querySelector('button[type=submit]');
        const syncPurchase = () => {
          const selected = variant.selectedOptions[0];
          const available = selected?.dataset.mmsAvailable === 'true';
          if (submit && form.dataset.submitting !== 'true') {
            submit.disabled = !available;
            submit.textContent = available ? 'Add to cart' : 'Sold out';
          }
          return available;
        };
        const renderChoices = selected => {
          controls.forEach((control, index) => {
            const matching = choices.filter(choice => selected.values.slice(0, index).every((prior, i) => choice.values[i] === prior));
            const values = [...new Set(matching.map(choice => choice.values[index]))];
            control.replaceChildren(...values.map(value => {
              const option = new Option(value, value, false, value === selected.values[index]);
              return option;
            }));
          });
        };
        if (controls.length && choices.length && choices.every(choice => choice.values.length === controls.length)) {
          const selected = choices.find(choice => choice.option.selected) || choices[0];
          renderChoices(selected);
          controls.forEach((control, index) => control.addEventListener('change', () => {
            const values = controls.map(select => select.value);
            const exact = choices.find(choice => choice.values.every((value, i) => value === values[i]));
            const matching = choices.filter(choice => values.slice(0, index + 1).every((value, i) => value === choice.values[i]));
            const next = exact || matching[0];
            if (!next) return;
            variant.value = next.option.value;
            renderChoices(next);
            variant.dispatchEvent(new Event('change', {bubbles: true}));
            log('INFO', 'VARIANT_SELECTED', {variantId: variant.value, available: next.available});
          }));
          variantFallback.hidden = true;
          choicesPanel.hidden = false;
        } else if (!controls.length && choices.length === 1 && choices[0].values[0] === 'Default Title') {
          variantFallback.hidden = true;
        }
        variant.addEventListener('change', syncPurchase);
        form.addEventListener('submit', event => {
          if (!syncPurchase()) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, true);
        syncPurchase();
        // A bookmarked sold-out variant must resolve to the same purchasable
        // selection shown by the fields, price, gallery and cart form.
        const requestedId = new URL(location.href).searchParams.get('variant');
        if (choices.length && requestedId && requestedId !== variant.value) {
          variant.dispatchEvent(new Event('change', {bubbles: true}));
          log('INFO', 'UNAVAILABLE_VARIANT_RESOLVED', {requestedId, variantId: variant.value});
        }
      }

    });
  } catch(error) {log('ERROR', 'PRODUCT_DETAILS_INIT', {trigger:'product form initialization',stack:error.stack});}
})();
